import React from 'react';
import './CookieInfo.css';

function setConsent() {
  localStorage.setItem('consentGiven', 'true');
  window.location.reload();
}

function CookieInfo() {
  return (
    <div className="cookie-info">
      <h1>Informacja o plikach cookie.</h1>
      <p>
        Na tej stronie wykorzystywane są pliki cookie do load balancingu 
        (optymalizacji ruchu) oraz tworzone przez Google Maps.
        Jeżeli nie chcesz z nich korzystać, zablokuj taką możliwość w przeglądarce. 
      </p>
      <button onClick={() => setConsent()} className="cookie-info-accept">OK, rozumiem</button>
    </div>
  );
}

export default CookieInfo;
